import routerOptions0 from "C:/Users/Viktor/Development/asufin-app-v2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}